import React from "react";
import Avatar from "react-avatar";
import { Link, useNavigate } from "react-router-dom";

const UserFriends = ({ friends }) => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="flex gap-2 justify-between items-center">
        <h1 className="text-xl font-bold">Friends</h1>
        <Link to="/friends">
          <p className="text-sm hover:underline">See all</p>
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-4">
        {/* // map through the friends and render the user */}
        {friends.map((user) => (
          <div
            className="flex flex-col items-center gap-2 cursor-pointer"
            onClick={() => navigate(`/profile/${user._id}`)}
            key={user._id}
          >
            <Avatar
              name={`${user.firstName} ${user.lastName}`}
              size="35"
              round={10}
            />
            <div>
              <p className="text-[13px]">@{user?.userName}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserFriends;
